module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid page-head-wrap"
  }, [_c('div', {
    staticClass: "container page-head"
  }, [_c('h3', {
    staticClass: "h4 text-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'top',
        params: {}
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left back-icon",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('b', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[4][1]"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 offset-lg-2 col-lg-8"
  }, [(_vm.apiErrorI18nKey) ? _c('div', {
    staticClass: "alert alert-danger mt-3",
    attrs: {
      "role": "alert"
    }
  }, [_c('b', [_c('trans-text', {
    attrs: {
      "i18nKey": _vm.apiErrorI18nKey
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('page-form', {
    on: {
      "tryForm": _vm.tryForm
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6"
  }, [_c('div', {
    staticClass: "my-4"
  }, [_c('router-link', {
    staticClass: "btn w-100 btn-lg btn-default",
    attrs: {
      "tag": "button",
      "to": {
        name: 'top',
        params: {}
      }
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[4][6]"
    }
  })], 1)], 1)])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cff436fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/DemoLogin.vue
// module id = 732
// module chunks = 0